export default __webpack_public_path__ + "static/media/token.ddc7fa0c.svg";